import axios from "@/axios";

export const namespaced = true;

const DefaultReconciliationStatusData = {
  reconciliationStatuses: {},
  reconciliationStatusInformation: false,
};

export const state = {
  reconciliationStatuses: {},
  reconciliationStatusInformation: false,
  reconciliationErrors: []
};

export const getters = {
  reconciliationStatuses: (state) => {
    return state.reconciliationStatuses;
  },
  reconciliationStatusInformation: (state) => {
    return state.reconciliationStatusInformation;
  },
  reconciliationErrors: (state) => {
    return state.reconciliationErrors;
  },
};

export const mutations = {
  SET_RECONCILIATION_STATUS(state, data) {
    state.reconciliationStatuses = data;
  },
  SET_RECONCILIATION_STATUS_INFORMATION(state, data) {
    state.reconciliationStatusInformation = data;
  },
  CLEAR_DATA(state) {
    state.reconciliationStatuses = DefaultReconciliationStatusData;
  },
  SET_ERRORS(state, data) {
    state.reconciliationErrors = data;
  },
  CLEAR_ERRORS(state) {
      state.reconciliationErrors = [];
  }
};

export const actions = {
  clearData({ commit }) {
    commit("CLEAR_DATA");
  },
  async saveReconciliationStatus({ commit }, data) {
    return await axios.post("api/reconciliationstatus/", data);
  },
  async getReconciliationStatus({ commit }, id) {
    return await axios.get(`api/reconciliationstatus/${id}`)
      .then(({ data }) => {
        commit("SET_RECONCILIATION_STATUS", data);
      });
  },
  async getReconciliationStatusInformation({ commit }, id) {
    return await axios
      .get(`api/reconciliationstatus/status/${id}`)
      .then(({ data }) => {
        commit("SET_RECONCILIATION_STATUS_INFORMATION", false);
        if(data && data.length === 0) {
          commit("SET_RECONCILIATION_STATUS_INFORMATION", true);
          commit("CLEAR_ERRORS");
      } else {
        commit("SET_RECONCILIATION_STATUS_INFORMATION", false);
          commit("SET_ERRORS", data);
      }
      });
  },
};
